const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
const PIPELINE_API_BASE_URL = (
    process.env.REACT_APP_PIPELINE_API_BASE_URL ||
    'https://s6034brjyk.execute-api.us-east-1.amazonaws.com'
).replace(/\/$/, '');
const DEFAULT_TIMEOUT_MS = 20000;

export const apiUrl = (path) => {
    if (!path || !String(path).startsWith('/api')) {
        return path;
    }

    if (!API_BASE_URL) {
        return path;
    }

    return `${API_BASE_URL}${String(path).replace(/^\/api/, '')}`;
};

export const apiFetch = (path, options = {}) => {
    const { timeoutMs = DEFAULT_TIMEOUT_MS, ...fetchOptions } = options;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

    return fetch(apiUrl(path), {
        ...fetchOptions,
        signal: fetchOptions.signal || controller.signal
    }).finally(() => {
        window.clearTimeout(timeout);
    });
};

export const pipelineApiFetch = (path, options = {}) => {
    const { timeoutMs = DEFAULT_TIMEOUT_MS, ...fetchOptions } = options;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
    const normalizedPath = String(path || '').startsWith('/') ? String(path) : `/${path}`;

    return fetch(`${PIPELINE_API_BASE_URL}${normalizedPath}`, {
        ...fetchOptions,
        signal: fetchOptions.signal || controller.signal
    }).finally(() => {
        window.clearTimeout(timeout);
    });
};

export const readJsonResponse = async (response, fallbackMessage = 'API request failed') => {
    const contentType = response.headers.get('content-type') || '';
    const text = await response.text();

    if (!contentType.includes('application/json')) {
        const preview = text.trim().slice(0, 120);
        throw new Error(`${fallbackMessage}: expected JSON but received ${contentType || 'unknown content type'}${preview ? ` (${preview})` : ''}`);
    }

    try {
        return text ? JSON.parse(text) : {};
    } catch (error) {
        throw new Error(`${fallbackMessage}: invalid JSON response`);
    }
};
